import { create } from "zustand"

export type ThemeMode = "dark" | "light"
export type ThemePreference = ThemeMode | "system"

type ThemeState = {
  mode: ThemeMode
  preference: ThemePreference
  setPreference: (preference: ThemePreference) => void
}

const THEME_STORAGE_KEY = "kada_video_frontend_theme"
const COLOR_SCHEME_MEDIA_QUERY =
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia("(prefers-color-scheme: dark)")
    : null

const getInitialThemePreference = (): ThemePreference => {
  if (typeof window === "undefined") return "light"

  const preference = window.localStorage.getItem(THEME_STORAGE_KEY)

  return preference === "dark" || preference === "system" ? preference : "light"
}

const resolveThemeMode = (preference: ThemePreference): ThemeMode =>
  preference === "system"
    ? COLOR_SCHEME_MEDIA_QUERY?.matches
      ? "dark"
      : "light"
    : preference

const INITIAL_PREFERENCE = getInitialThemePreference()

export const useThemeStore = create<ThemeState>((set) => ({
  mode: resolveThemeMode(INITIAL_PREFERENCE),
  preference: INITIAL_PREFERENCE,
  setPreference: (preference) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(THEME_STORAGE_KEY, preference)
    }

    set({ mode: resolveThemeMode(preference), preference })
  },
}))

COLOR_SCHEME_MEDIA_QUERY?.addEventListener("change", ({ matches }) => {
  if (useThemeStore.getState().preference !== "system") return

  useThemeStore.setState({ mode: matches ? "dark" : "light" })
})
